<template>
  <div class="order-card-wrapper"  @click="toOrderDetail">
    <div class="order-title">
      <div class="order-title-text">
        <span>{{ list.vehicle_name }}</span>
      </div>
      <div class="order-price">
        <span v-if="list.payamount > 0 && list.tea_first == 1">￥{{ list.payamount }}</span>
        <span v-else>￥{{ list.amount }}</span>
      </div>
    </div>
    <div style="padding:0 .5rem;box-sizing: border-box">
      <div class="order-content">
      <div class="sites" style="background-color: #1a6b45;color: #fff;border-radius: 5px;padding: 5px;">
<div class="site start-site">{{parseTime(list.ride_date) }}</div>
          <div class="site end-site">{{weekTime(list.ride_date) }}</div>
      </div>
        <div class="sites">
          <div class="site start-site">
            <span>{{ list.origin_time }}</span>
            <span class="start-dot">上</span>{{ startAddress }}</div>
          <div class="site end-site">
            <span>{{ list.end_time }}</span>
            <span class="end-dot">下</span>{{ endAddress }}</div>
        </div>
        <div class="order-cancel" v-if="list.order_status==='created'" @click="onCancelClick">取消</div>
        <div class="order-cancel"
             v-if="list.order_status==='paid' && list.is_bp!=1" @click="onCancelClick" >取消</div>
        <div class="order-evaluation"
             v-if="list.order_status==='expired'" >已乘车</div>
			 <div class="order-evaluation"
             v-if="list.order_status==='paid'  && list.is_bp==1">补票单</div>
        <div class="order-evaluation"
             v-if="list.order_status==='evaluation'">已评价</div>
             <div class="order-evaluation"
             v-if="list.order_status==='cancel'">已取消</div>
      </div>
      
      <footer class="order-footer" v-if="list.order_status==='created'">
        <span class="countdown" v-if="is_down">倒计时: {{ countdown }}<i class="iconfont icon-wifi"></i></span>
         <span class="countdown" v-else></span>

          <span class="pay-btn" v-if="list.is_ticket == 1 && list.ticket_time ==null">待补票</span>
        <span class="pay-btn" v-else >支付</span>

      </footer>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import Order from '@/apis/Order';
import time from '@/utils/time';
import moment from 'moment';
export default {
  name: 'OrderCard',
  mixins: [time],
  props: {
    list: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'created',
    },
  },
  computed: {
    startAddress() {
      const address = this.list.vehicle_name;
      return address.slice(0, address.indexOf('-'));
    },
    endAddress() {
      const address = this.list.vehicle_name;
      return address.slice(address.indexOf('-') + 1);
    },
    
  },
  data() {
    return {
      canceling: false,
      is_down:false,
      weekArr:["星期日", "星期一", "星期二", "星期三", "星期四","星期五", "星期六"]
    };
  },
  created() {
    console.log(this.type === 'created');
    if (this.type === 'created' && this.list.id) {
      if(this.list.is_ticket == 1){
        if(this.list.ticket_time !==null){
           this.count(1);
           this.is_down=true;
        }
        
      }else{
         this.count(0);
         this.is_down=true;
      }
      
    }
  },
  watch: {
    countdown(val) {
      if (val === '00:00') {
        this.$emit('reload');
      }
    },
  },
  methods: {
parseTime(d) {
      return moment(d).format('MM-DD');
    },
weekTime(d) {

       var day = new Date(moment(d).format('YYYY-MM-DD'));

       var wk = day.getDay();
       return this.weekArr[wk];
    },

    toMap(e) {
      this.$router.push('/map');
      e.preventDefault();
      e.stopPropagation();
    },
    toOrderDetail(e) {
      console.log(e);
      // eslint-disable-next-line no-underscore-dangle
      // Toast.success(JSON.stringify(this.$router));
      // // Toast.success(e.path[0]);
      // e.preventDefault()
      // e.stopPropagation();
      // eslint-disable-next-line no-underscore-dangle
	  if (e.target._prevClass === 'order-cancel') {
	    return;
	  }
	  if(this.list.is_bp==1){
		  this.$router.push({
		    path: this.type === 'created' ? '/repair' : '/orderDetail',
		    query: { ...this.list, type: this.type },
		  });
	  }else{
		
		this.$router.push({
		  path: this.type === 'created' ? '/order' : '/orderDetail',
		  query: { ...this.list, type: this.type },
		});  
	  }
      

      // this.$emit('to', );
    },
    async cancelOrder() {
      this.canceling = true;
      const toast = Toast.loading({
        message: '取消中',
        forbidClick: true,
      });
      const res = await Order.cancelOrder({ id: this.list.id });
      const { code, message } = res;
      toast.clear();
      if (Number(code) !== 1) {
        this.canceling = false;
        Toast.fail(message);
        return;
      }
      Toast.success(this.list.is_bp==1?'取消补票成功':'取消预约成功');
      setTimeout(() => {
        this.$emit('reload');
      }, 2000);
    },
    onCancelClick() {
      Dialog.alert({
        title: '提示',
        message: this.list.is_bp==1?'确认取消补票':'确认取消预约？',
        showCancelButton: true,
      }).then(() => {
        this.cancelOrder();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";

.order-card-wrapper {
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: .5rem;
  overflow:hidden;
}

.order-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  height: 44px;
  line-height: 44px;
  color: rgb(51, 51, 51);
  font-family: PingFang SC;
  font-weight: 500;
  border-bottom: 1px solid #f1f1f1;
  background: rgba(232, 232, 232, 1);;
  .order-title-text {
    font-size: 14px;
    font-weight: 550;
    flex: 3;
    @include text-ellipsis();
  }
  .order-status {
    flex-shrink: 0;
  }
  .order-label {
    font-weight: normal;
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 12px;
    background-color: #72da2d;
    color: #fff;
    text-align: center;
    line-height: 20px;
    transform: scale(0.8);
  }
  .order-price {
    font-size: 16px;
    color: #f40;
  }
}

.order-content {
  padding: 10px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .order-cancel{
    border: 1px solid rgba(153, 153, 153, 1);
    color: rgba(153, 153, 153, 1);
    border-radius: 5px;
    padding:.2rem .8rem;
  }
  .order-evaluation{
    padding:.2rem .8rem;
    border-radius: 5px;
    color:rgb(153, 153, 153);
    background-color: rgb(238, 238, 238);
  }
}

.order-footer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #ccc;
  .countdown{
    color: rgba(26, 107, 69, 1);
    line-height: 1.2rem;
    font-size: 1rem;
    .icon-wifi{
      font-size: 2rem;
      transform: translate(-34%,34%);
      display: inline-block;
    }
  }
  .pay-btn{
    width: 4rem;
    text-align: center;
    border-radius: 5px;
    padding:.2rem 0;
    display: block;
    color: rgba(26, 107, 69, 1);
    border: 1px solid rgba(26, 107, 69, 1);
  }
}

.start-dot, .end-dot{
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  transform: scale(0.6);
  margin:0 10px;
  color: #fff;
  text-align: center;
  line-height: 2rem;
}

.order-time {
  color: #4d4d4d;
  font-size: 16px;
  margin-bottom: 5px;
  span {
    font-size: 14px;
    margin-left: 4px;
  }
}

.sites {
  color: #666666;
  .site {
    height: 25px;
    line-height: 25px;
  }
}

.start-dot {
  background-color: rgba(26, 107, 69, 1);;
}

.end-dot {
  background-color: rgba(173, 0, 4, 1);;
}

.order-fotter {
  border-top: 1px solid #f1f1f1;
  display: flex;
  * {
    flex: 1;
    overflow-x: hidden;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}
</style>
